export const formValues = {
  Name: "Hoppia avatar",
  Description: "Avatar de hoppia",
  Picture: "https://hoppia.s3-us-west-2.amazonaws.com/events/2020/09/event_hoppia.jpg",
  CharacterIndex: "CH99",
  Index: 100000000,
}